var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Existing group", name: "existingGroup" } },
            [
              _c("select-send-list", {
                ref: "selectSendList",
                attrs: {
                  "search-url": _vm.searchUrl,
                  "import-url": _vm.importUrl,
                },
                on: { stored: _vm.onImportedSuccess },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Create group", name: "createGroup" } },
            [
              _c("create-send-list", {
                ref: "createSendList",
                attrs: {
                  "can-select-user": _vm.canSelectUser,
                  users: _vm.users,
                  "store-url": _vm.storeUrl,
                },
                on: { stored: _vm.onStoredSendList },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }